import AgentChatManager from '@src/logic/agentchatmanager';
import {
  awaitChatClose,
  chatClosed,
  chatCloseFailure,
} from '@src/reducers/chats';
import { ChatTrayXfer } from '@src/types/chats';
import { useDispatch } from 'react-redux';

const useChatActions = () => {
  const dispatch = useDispatch();

  return {
    pinChat(chatId: string) {
      AgentChatManager.requestPinChat(chatId);
    },
    activeChatWS(chatId: string) {
      AgentChatManager.activeChatWS(chatId);
    },
    activateChat(chatId: string, agentId: number) {
      AgentChatManager.requestSetActiveChat(chatId, agentId);
    },
    resumeChat(chatId: string, templatedMsgId: string, setActive = false) {
      AgentChatManager.requestResumeChat(chatId, templatedMsgId, setActive);
    },
    closeChat(chatId: string) {
      dispatch(awaitChatClose());
      AgentChatManager.requestCloseChat(chatId)
        .then(closedChat => {
          dispatch(chatClosed(closedChat.id));
        })
        .catch(error => {
          dispatch(chatCloseFailure({ code: error.errorType }));
        });
    },
    cancelChatTransfer(chatTransfer: ChatTrayXfer) {
      AgentChatManager.cancelAgentChatTransfer(chatTransfer);
    },
    rejectChatTransfer(chatTransfer: ChatTrayXfer) {
      AgentChatManager.rejectAgentChatTransfer(chatTransfer);
    },
    acceptChatTransfer(chatTransfer: ChatTrayXfer) {
      AgentChatManager.acceptAgentChatTransfer(chatTransfer);
    },
    pickupChat(chatId: string, agentId: number) {
      AgentChatManager.requestChatPickup(chatId, agentId);
    },
    pickupChatTransfer(chatTransfer: ChatTrayXfer) {
      AgentChatManager.pickupAgentChatTransfer(chatTransfer);
    },
  };
};

export default useChatActions;
